import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '@tableau/data-catalog-shared';
import * as React from 'react';
import { LensFieldsByIdQuery, LensFieldsByIdQueryVariables, LensFieldsByIdQuery_lenses_fieldsConnection_nodes, LensFieldsByIdQuery_lenses_fieldsConnection_nodes_datasourceField_ColumnField } from '../../../gen-src/queries/LensFieldsByIdQuery';
import { LensFieldOrderField, OrderDirection } from '../../../gen-src/queries/globalTypes';
import { LensFieldsByIdQueryGql } from '../../queries/LensFieldsByIdQueryGql';
import { iconForField } from '../field/functions/FieldFunctions';
import { FieldsValidSortFields } from '../sorting/sortProviders/FieldsGridSortProvider';
import { LensFieldsDisplayGrid, LensFieldsDisplayGridRowData } from './LensFieldsDisplayGrid';

export type LensFieldsQueryGridProps = GridSortProps<FieldsValidSortFields> & Readonly<{
  vizportalUrlId: string;
  rowCount: number | null;
}>;

export type QueryVariables = LensFieldsByIdQueryVariables;
export type QueryResults = LensFieldsByIdQuery;
export type QueryResultListNode = LensFieldsByIdQuery_lenses_fieldsConnection_nodes;
export type GridRowData = LensFieldsDisplayGridRowData;

const selectConnectionListResult = (resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null => {
  return resultData?.lenses[0] && resultData.lenses[0].fieldsConnection;
}

const mapResultNode = (field: QueryResultListNode, resultData: QueryResults): GridRowData => {
  return {
    ...field.datasourceField,
    dataType: (field.datasourceField as LensFieldsByIdQuery_lenses_fieldsConnection_nodes_datasourceField_ColumnField).dataType || null,
    lensId: resultData.lenses[0].vizportalUrlId,
    fieldIcon: iconForField(field.datasourceField),
  };
}

export const LensFieldsQueryGrid: React.FC<LensFieldsQueryGridProps> = props => {
  return <PaginatedQueryWrapper<
    QueryVariables, QueryResults, QueryResultListNode, GridRowData>
    queryGql={LensFieldsByIdQueryGql}
    partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: { field: LensFieldOrderField.ID, direction: OrderDirection.DESC } }}
    selectConnectionListResult={selectConnectionListResult}
    mapResultNode={mapResultNode}
    hackyUpdateNumber={0}>
    {({ rowStore }) => (
      <LensFieldsDisplayGrid
        rowStore={rowStore}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder} />
    )}
  </PaginatedQueryWrapper >;
}
